import { render, staticRenderFns } from "./uctask.vue?vue&type=template&id=4e96244e&scoped=true"
import script from "./uctask.vue?vue&type=script&lang=js"
export * from "./uctask.vue?vue&type=script&lang=js"
import style0 from "./uctask.vue?vue&type=style&index=0&id=4e96244e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96244e",
  null
  
)

export default component.exports